import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { TabMenuModule } from 'primeng/tabmenu';
import { TieredMenuModule } from 'primeng/tieredmenu';

import {
  BaseBreadcrumbComponent,
  BaseButtonComponent,
  BaseDropdownComponent,
  BaseFormComponent,
  BaseSearchComponent,
  BaseStatusComponent,
  BaseTableComponent,
  CollapseComponent,
  FilesUploaderComponent,
  RevisionHistoryComponent,
} from '@d-components';

import { CustomCellDirective } from '@d-components/table/custom-cell.directive';
import { FormService } from '@d-services';
import { TableExportService } from '@d-services/other/table-export.service';
import { CustomPipesModule } from '@d-pipes/pipes.module';
import { ListingFilterDirective } from '../directives/listing-filter.directive';

@NgModule({
  imports: [
    CustomPipesModule,
    CollapseComponent,
    BaseButtonComponent,
    BaseFormComponent,
    BaseSearchComponent,
    BaseTableComponent,
    BaseBreadcrumbComponent,
    FilesUploaderComponent,
    BaseDropdownComponent,
    BaseStatusComponent,
    CustomCellDirective,
    RevisionHistoryComponent,
    ListingFilterDirective,
    TieredMenuModule,
  ],
  exports: [
    CustomPipesModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    RouterModule,
    TranslateModule,
    TabMenuModule,
    BaseButtonComponent,
    BaseFormComponent,
    BaseSearchComponent,
    BaseTableComponent,
    BaseBreadcrumbComponent,
    FilesUploaderComponent,
    BaseDropdownComponent,
    CollapseComponent,
    BaseStatusComponent,
    CustomCellDirective,
    RevisionHistoryComponent,
    TieredMenuModule,
  ],
  providers: [TableExportService, FormService],
})
export class CommonSharedModule {}
